import {
  GENERATE_QR_CODE_START,
  GENERATE_QR_CODE_SUCCESS,
  GENERATE_QR_CODE_ERROR,
} from "../actions/QRCode/generateQRCode";

const initialState = {
  qrData: null,
  isLoading: false,
  error: null,
  errorCode: null,
  status: null,
  reference: null,
  url: null,
};

export default function qrcode(state = initialState, action) {
  switch (action.type) {
    case GENERATE_QR_CODE_START:
      return {
        ...state,
        isLoading: true,
        error: null,
        errorCode: null,
      };

    case GENERATE_QR_CODE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        qrData: action.payload.qrCode,
        reference: action.payload.reference,
        url: action.payload.url,
        error: null,
        errorCode: null,
        status: "success",
      };

    case GENERATE_QR_CODE_ERROR:
      return {
        ...state,
        isLoading: false,
        qrData: null,
        reference: null,
        url: null,
        error: action.payload.error,
        errorCode: action.payload.code,
        status: "error",
      };

    default:
      return state;
  }
}
